import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import UiMessage, { type UiMessageType } from '@/modules/ui/components/ui/UiMessage.vue';

type SchemaMessageArgs = SchemaControlArgs & {
  type: UiMessageType;
};

export class SchemaMessage extends SchemaControl<never> {
  readonly component = UiMessage;
  readonly type: UiMessageType;

  constructor(args: SchemaMessageArgs) {
    super(args);

    this.type = args.type;
  }
}
